/**
 * 列表页码统一重置工具。
 * 查询、切换组织树时向上扫描父组件，将常见分页字段重置为第 1 页，
 * 避免仍停留在第 N 页导致“无数据”。创建于 2026-08-02
 */

/** 直接挂在组件 data 上的页码字段 */
const DIRECT_PAGE_KEYS = ['page', 'currentPage', 'teacherPage', 'pageIndex', 'pageNum']

/** 嵌套分页对象上的页码字段 */
const NESTED_PAGE_KEYS = ['page', 'Page', 'currentPage', 'CurrentPage']

/**
 * 判断工具栏按钮是否为查询类动作。
 * @param {Object} item - Toolbar 按钮配置
 * @returns {boolean}
 */
export function isQueryToolbarAction(item) {
  if (!item) return false
  if (item.forceAction === true || item.isQueryToolbar === false) return false

  const func = String(item.Func || item.func || '').trim().toLowerCase()
  const name = String(item.name || item.Name || '').trim()

  if (func === 'handlequery' || func === 'handlesearch') return true
  if (/^(query|search)/.test(func) && !/^open/.test(func)) return true
  if (name === '查询' || name === '搜索') return true

  return false
}

/**
 * 重置单个组件上的常见分页字段。
 * @param {Vue} vm
 */
function resetPageOnVm(vm) {
  if (!vm || !vm.$data) return
  const data = vm.$data

  DIRECT_PAGE_KEYS.forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(data, key)) return
    const value = data[key]
    if (typeof value === 'number' && value !== 1) {
      vm[key] = 1
    } else if (value && typeof value === 'object') {
      NESTED_PAGE_KEYS.forEach((nestedKey) => {
        if (typeof value[nestedKey] === 'number' && value[nestedKey] !== 1) {
          vm.$set(value, nestedKey, 1)
        }
      })
    }
  })

  ;['pagination', 'filters', 'pageInfo'].forEach((containerKey) => {
    if (!Object.prototype.hasOwnProperty.call(data, containerKey)) return
    const container = data[containerKey]
    if (!container || typeof container !== 'object') return
    NESTED_PAGE_KEYS.forEach((nestedKey) => {
      if (typeof container[nestedKey] === 'number' && container[nestedKey] !== 1) {
        vm.$set(container, nestedKey, 1)
      }
    })
  })
}

/**
 * 从当前组件向上找根，重置祖先链上的列表页码。
 * @param {Vue} startVm - 起点组件（通常为 Toolbar / DepartmentPane）
 */
export function resetParentListPage(startVm) {
  let current = startVm
  while (current) {
    resetPageOnVm(current)
    current = current.$parent
  }
}
